import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type A5StaticDatum = {
  id: number;
  name?: string;
  isin?: string;
  code?: string;
  ticker?: string;
  currency?: string;
  asset_class_1?: string;
  asset_class_2?: string;
  has_transactions?: boolean;
  has_time_series?: boolean;
};

export const porfolios_columns: ColumnDef<A5StaticDatum>[] = [
  {
    accessorKey: "id",
    header: () =>
      i18n.t("a5_static_data.columns.id", {
        ns: "tables",
        defaultValue: "Id",
      }),
  },
  {
    accessorKey: "name",
    header: () =>
      i18n.t("a5_static_data.columns.name", {
        ns: "tables",
        defaultValue: "Nom",
      }),
  },
  {
    accessorKey: "isin",
    header: () =>
      i18n.t("a5_static_data.columns.isin", {
        ns: "tables",
        defaultValue: "ISIN",
      }),
  },
  {
    accessorKey: "code",
    header: () =>
      i18n.t("a5_static_data.columns.code", {
        ns: "tables",
        defaultValue: "Code",
      }),
  },
  {
    accessorKey: "ticker",
    header: () =>
      i18n.t("a5_static_data.columns.ticker", {
        ns: "tables",
        defaultValue: "Ticker",
      }),
  },
  {
    accessorKey: "currency",
    header: () =>
      i18n.t("a5_static_data.columns.currency", {
        ns: "tables",
        defaultValue: "Devise",
      }),
  },
  {
    accessorKey: "asset_class_1",
    header: () =>
      i18n.t("a5_static_data.columns.asset_class_1", {
        ns: "tables",
        defaultValue: "Classe d'actifs",
      }),
  },
  {
    accessorKey: "asset_class_2",
    header: () =>
      i18n.t("a5_static_data.columns.asset_class_2", {
        ns: "tables",
        defaultValue: "Sous-classe d'actifs",
      }),
  },
  {
    id: "actions",
    cell: ({ row }) => {
      const hasTransactions = row.original.has_transactions;
      const hasTimeSeries = row.original.has_time_series;

      return (
        <div className="flex gap-11 justify-end">
          <div className="flex gap-3">
            <ExternalLink
              href={toWorkspacePath("/admin/a5/a5_transactions")}
              queryParams={{
                a5_static_data_id_equal: row.getValue("id"),
              }}
              className={`text-xs ${
                !hasTransactions ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              {i18n.t("actions.transactions")}
            </ExternalLink>
            <ExternalLink
              href={toWorkspacePath("/admin/a5/a5_time_series")}
              queryParams={{
                a5_static_data_id_equal: row.getValue("id"),
              }}
              className={`text-xs ${
                !hasTimeSeries ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              {i18n.t("actions.valuations", { defaultValue: "Valorisations" })}
            </ExternalLink>
          </div>
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];

// export const porfolios_audit_columns = getAuditColumns<A5StaticDatum>(porfolios_columns)</div>
